import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const documentTagServices = {
  getDocumentTagData,
};

async function getDocumentTagData(status, searchData, page, length) {
  let response;
  if (page && length) {
    response = await fetch(
      `${config.API_URL}getDocumentTagData/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL}getDocumentTagData/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}